/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const MaxPlagiarismMatchesSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('MAX_PLAGIARISM_MATCHES')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class MaxPlagiarismMatchesSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return MaxPlagiarismMatchesSettingParser.decode(input).map(res => new MaxPlagiarismMatchesSetting(res));
    }
    static unsafeDecode(input) {
        return MaxPlagiarismMatchesSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return MaxPlagiarismMatchesSettingParser.encode(data);
    }
    static schema() {
        return MaxPlagiarismMatchesSettingParser.schema();
    }
}
